import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Card, Col, FormGroup, Row } from "react-bootstrap";
import { getAgencyHappycallGrades } from "../../store/api/HappycallAPI";
import DatePicker from "react-datepicker2";
import moment from "moment-jalali";
import { ChatRight, Clipboard2DataFill, FileEarmarkExcelFill, Headphones, List, PrinterFill } from "react-bootstrap-icons";
import BihamtaTable from "../../../Components/BihamtaTable";
import Loader from "react-loader-spinner";
import ModalSelectStaff from "../../../Components/Modals/ModalSelectStaff";
import { BarChart, Bar, YAxis, XAxis, ResponsiveContainer, Legend, CartesianGrid, LineChart, Line, Label, AreaChart, Area } from "recharts";
import ModalPrintViewer from "../../../Components/Modals/ModalPrintViewer";
import { exportToExcel } from "../../../store/api/CommonFunctions";
import ModalHappyCall from "../../../Components/Modals/ModalHappyCall";

export default function AgencyHappycallGrades() {
    const [dataList, setDataList] = useState(null);
    const [pending, setPending] = useState(false);
    const [chartType, setChartType] = useState("Bar");
    const inputCDateFrom = useRef()
    const inputCDateTo = useRef()
    const inputDateFrom = useRef()
    const inputDateTo = useRef();
    const inputEDateFrom = useRef();
    const inputEDateTo = useRef();
    const chartContainer = useRef();
    // const [questionList, setQuestionList] = useState([]);
    const [searchData, setSearchData] = useState({});
    const [modalStaff, setModalStaff] = useState({ show: false });
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [modalHappycall, setModalHappyCall] = useState({ show: false });
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "سرویس", colName: "PServiceType+InvoiceNumber", showInMobile: true, colType: "string", showCondition: () => Number(searchData.AgencyID) > 0 },
        { colTitle: "محصول", colName: "HolderName+ProductName+ProductModel", colType: "string", showCondition: () => Number(searchData.AgencyID) > 0 },
        { colTitle: "مشتری", colName: "CustomerName", showCondition: () => Number(searchData.AgencyID) > 0 },
        { colTitle: "شماره تماس", colName: "CustomerMobile+CustomerPhone", colType: "string", showCondition: () => Number(searchData.AgencyID) > 0 },
        { colTitle: "نماینده", colName: "AgencyCode+AgencyName", colType: "string", showCondition: () => !(Number(searchData.AgencyID) > 0) },
        { colTitle: "سطح", colName: "Grade" }
    ]
    const rowButtons = [];
    if ((Number(searchData.AgencyID) > 0)) {
        rowButtons.push(
            {
                title: "پرسشنامه",
                type: "common",
                tooltip: "پرسشنامه",
                //className: string;
                onclick: showModalHappyCall,
                icon: <Headphones size={18} color="blue" />
            }
        )
    }
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ textAlign: "center" }}>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("Grade", "سطح رضایت")}
                        </span>
                    ))
                }
            </div>
        );
    }
    const onServiceTypeChange = (serviceType) => {
        //const activeInInstall = serviceType?.toLowerCase() === "install";
        //const activeInRepair = serviceType?.toLowerCase() === "repair";
        searchData.ServiceType = serviceType;
        // getHappycallQuestionList(0, activeInInstall, activeInRepair, setQuestionList);
    }
    const showModalAgency = () => {
        const onSelect = (data) => {
            setSearchData({ ...searchData, AgencyID: data?.ID, AgencyName: data?.LastName });
        }
        setModalStaff({ show: true, forAgency: true, onSelect: onSelect });
    }
    const search = () => {
        setDataList("PENDING");
        searchData.PServiceType = searchData.ServiceType === "install" ? "نصب" : searchData.ServiceType === "repair" ? "تعمیر" : "";
        searchData.PCreateDateFrom = inputCDateFrom.current.input.value;
        if (searchData.PCreateDateFrom === "") {
            searchData.CreateDateFrom = null;
        }
        searchData.PCreateDateTo = inputCDateTo.current.input.value;
        if (searchData.PCreateDateTo === "") {
            searchData.CreateDateTo = null;
        }
        searchData.PFirstContactDateFrom = inputDateFrom.current.input.value;
        if (searchData.PFirstContactDateFrom === "") {
            searchData.FirstContactDateFrom = null;
        }
        searchData.PFirstContactDateTo = inputDateTo.current.input.value
        if (searchData.PFirstContactDateTo === "") {
            searchData.FirstContactDateTo = null;
        }
        searchData.PEventDateFrom = inputEDateFrom.current.input.value;
        if (searchData.PEventDateFrom === "") {
            searchData.EventDateFrom = null;
        }
        searchData.PEventDateTo = inputEDateTo.current.input.value;
        if (searchData.PEventDateTo === "") {
            searchData.EventDateTo = null;
        }

        getAgencyHappycallGrades(searchData, setDataList);
    }
    const showService = (row) => {
        if (Number(row.ServiceID) > 0)
            window.open(`/Services/Service/${row.ServiceID}/${row.ServiceType}`);
    }
    const handlePrintChart = () => {
        const chartDiv = chartContainer.current;
        if (!chartDiv) return;

        // گرفتن SVG داخل div نمودار
        const svgElement = chartDiv.querySelector("svg");
        if (!svgElement) return;

        const clonedSVG = svgElement.cloneNode(true);

        // باز کردن پنجره جدید
        const printWindow = window.open("", "_blank", "width=900,height=650");
        if (!printWindow) return;

        // پاک کردن body پنجره جدید
        printWindow.document.body.innerHTML = "";

        // اضافه کردن SVG کلون شده
        printWindow.document.body.appendChild(printWindow.document.importNode(clonedSVG, true));

        // استایل‌ها برای چاپ (اختیاری)
        const style = document.createElement("style");
        style.textContent = `
    svg { width: 600px; height: 300px; }
    text { font-family: Vazir, sans-serif; }
    body { text-align: center; margin: 0; padding: 20px;font-family: Vazir }
  `;
        printWindow.document.head.appendChild(style);

        // چاپ
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    const handlePrint = (e) => {
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "AgencyHappycallGrades" });
    }
    function toExcel() {
        const url = "api/HappycallAPI/GetAgencyHappycallGrades";
        const searchArgs = { ...searchData };
        setPending(true);
        exportToExcel("AgencyHappycallGrades", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showModalHappyCall(row) {
        if (!(Number(row.ServiceID) > 0)) {
            return;
        }
        setModalHappyCall({
            show: true,
            ProductID: row.ProductID,
            ServiceType: row.ServiceType,
            ServiceID: row.ServiceID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            InvoiceNumber: row.InvoiceNumber,
            PServiceType: row.ServiceType === "repair" ? "تعمیر" : "نصب",
            ProductSerial: row.ProductSerial,
            CustomerName: row.CustomerName,
            CustomerPhone: row.CustomerPhone,
            CustomerMobile: row.CustomerMobile,
            ContactDate: row.FirstContactDate ? moment(row.FirstContactDate).format("jYYYY/jMM/jDD HH:mm") : "",
            SendDeliveryDate: row.SendDeliveryDate ? moment(row.SendDeliveryDate).format("jYYYY/jMM/jDD HH:mm") : ""
        })
    }
    return (
        <div className="container-fluid mt-2" style={{ minHeight: '80vh', textAlign: "right" }}>
            <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData} jsonObject={dataList?.Data} fetchBody={{ ...searchData }} />
            <ModalSelectStaff popData={modalStaff} setPopSelectStaff={setModalStaff} />
            <ModalHappyCall popData={modalHappycall} setPopData={setModalHappyCall} />
            <br />
            <Row className="rowBorder">
                <div className="col-md-2 form-group">
                    <label>نوع سرویس:</label>
                    <select className="search-input" onChange={e => onServiceTypeChange(e.target.value)}>
                        <option value="">انتخاب کنید</option>
                        <option value="repair">تعمیر</option>
                        <option value="install">نصب</option>
                    </select>
                </div>
                <div className="col-md-2 form-group">
                    <label>نماینده:</label>
                    <input className="search-input" value={searchData.AgencyName ?? ""} />
                    <Button className="btn-input-tiny" onClick={showModalAgency} style={{ top: 24, left: 14 }}><List size={18} /></Button>
                </div>
                {/*<div className="col-md-2 form-group">
                    <label>مقیاس: </label>
                    {questionList === "PENDING" &&
                        <Loader color="#bb1370" type="BallTriangle" width={25} height={25} />
                    }
                    {Array.isArray(questionList) &&
                        <select className='search-input' onChange={e => searchData.QuestionID = e.target.value}>
                            <option value="">انتخاب کنید</option>
                            {
                                questionList.map((item, i) => <option key={i} value={item.ID}>{item.QuestionText}</option>)
                            }
                        </select>
                    }
                </div>*/}
                <div className="col-md-2 form-group">
                    <label>تاریخ پذیرش از:</label>
                    <DatePicker ref={inputDateFrom} isGregorian={false} timePicker={false} className="search-input"
                        value={searchData.FirstContactDateFrom ? moment(searchData.FirstContactDateFrom) : null}
                        onChange={value => { searchData.FirstContactDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-2 form-group">
                    <label htmlFor="">تاریخ پذیرش تا:</label>
                    <DatePicker ref={inputDateTo} isGregorian={false} timePicker={false} className="search-input"
                        value={searchData.FirstContactDateTo ? moment(searchData.FirstContactDateTo) : null}
                        onChange={value => { searchData.FirstContactDateTo = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-2 form-group">
                    <label>تاریخ ثبت از:</label>
                    <DatePicker ref={inputCDateFrom} isGregorian={false} timePicker={false} className="search-input"
                        value={searchData.CreateDateFrom ? moment(searchData.CreateDateFrom) : null}
                        onChange={value => { searchData.CreateDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-2 form-group">
                    <label>تاریخ ثبت تا:</label>
                    <DatePicker ref={inputCDateTo} isGregorian={false} timePicker={false} className="search-input"
                        value={searchData.CreateDateTo ? moment(searchData.CreateDateTo) : null}
                        onChange={value => { searchData.CreateDateTo = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-2 form-group">
                    <label>تاریخ انجام از:</label>
                    <DatePicker ref={inputEDateFrom} isGregorian={false} timePicker={false} className="search-input"
                        value={searchData.EventDateFrom ? moment(searchData.EventDateFrom) : null}
                        onChange={value => { searchData.EventDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                </div>
                <div className="col-md-2 form-group">
                    <label>تاریخ انجام تا:</label>
                    <DatePicker ref={inputEDateTo} isGregorian={false} timePicker={false} className="search-input"
                        value={searchData.EventDateTo ? moment(searchData.EventDateTo) : null}
                        onChange={value => { searchData.EventDateTo = value.local("en").format("YYYY/MM/DD") }} />
                </div>
            </Row>
            <Button className="group-Btn mt-1 mb-1" onClick={search}><Clipboard2DataFill size={18} />&nbsp;خروجی گزارش</Button>
            {!pending &&
                <div style={{ padding: 3, width: "100%", textAlign: "left", marginTop: "1px" }}>
                    <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />&nbsp;
                    <PrinterFill onClick={handlePrint} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                </div>}
            {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
            <BihamtaTable rowButtons={rowButtons} columns={tableCols} dataList={dataList} maxHeight={500} rowClick={showService} style={{ whiteSpace: "nowrap" }} />
            {dataList?.Data?.length > 0 &&
                < div className="rowBorder mt-3">
                    <div className="rowTitle"><PrinterFill size={23} onClick={handlePrintChart} color="green" className="hoverIcon" /></div>
                    <FormGroup className="col-md-2" style={{ paddingRight: "50px" }}>
                        <select className="tableRowInput" onChange={e => setChartType(e.target.value)} >
                            <option value="Bar">نمودار ستونی</option>
                            <option value="Line">نمودار خطی</option>
                            <option value="Area">ناحیه هشدار</option>
                        </select>
                    </FormGroup>
                    <Row className="mt-1" style={{ margin: "0", height: "200px", paddingTop: 0 }} ref={chartContainer}>

                        <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                            {chartType === "Bar" &&
                                <BarChart data={dataList.Data}>
                                    <Legend align="center" content={renderLegend} verticalAlign="bottom" style={{ textAlign: "center" }} />
                                    <XAxis dataKey={searchData.AgencyID ? "InvoiceNumberAndType" : "AgencyName"} style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                    <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                    <CartesianGrid />
                                    <Bar dataKey="Grade" fill="#1e7bbdff" label={{ position: 'top' }} isAnimationActive={false} />

                                </BarChart>
                            }
                            {chartType === "Line" &&
                                <LineChart data={dataList.Data} className="barChart">
                                    <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                    <XAxis dataKey={searchData.AgencyID ? "InvoiceNumberAndType" : "AgencyName"} style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} padding={{ left: 15 }} />
                                    <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                    <CartesianGrid />
                                    <Line dataKey="Grade" type="monotone" stroke="#bd2070" label={{ position: 'top' }} isAnimationActive={false} />
                                </LineChart>
                            }
                            {chartType === "Area" &&
                                <AreaChart className="barChart"
                                    data={[{ Grade: dataList.Data[dataList.Data.length - 1].Grade, AgencyName: "" }, ...dataList.Data]}
                                >
                                    <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey={searchData.AgencyID ? "InvoiceNumberAndType" : "AgencyName"} />
                                    <YAxis style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={1} />
                                    <Area type="monotone" dataKey="Grade" stroke="#8884d8" fill="#8884d8" isAnimationActive={false} />
                                </AreaChart>
                            }
                        </ResponsiveContainer>
                    </Row>
                </div>}
        </div>
    )
}